import { Table, Skeleton } from '@nimbus-ds/components';

export function TransferListRowSkeleton() {
  return (
    <Table.Row>
      <Table.Cell>
        <Skeleton width="98px" height="24px" />
      </Table.Cell>
      <Table.Cell>
        <Skeleton width="260px" height="24px" />
      </Table.Cell>
      <Table.Cell>
        <Skeleton width="260px" height="24px" />
      </Table.Cell>
      <Table.Cell>
        <Skeleton width="120px" height="24px" />
      </Table.Cell>
      <Table.Cell>
        <Skeleton width="124px" height="24px" />
      </Table.Cell>
    </Table.Row>
  );
}

export default TransferListRowSkeleton;
